import React from "react";
import { Image, Text, View, Page, Document, StyleSheet, Rect } from '@react-pdf/renderer';
import { Fragment } from "react";
import { Font } from "@react-pdf/renderer";
import IRANSans from '../../../fonts/IRANSans.ttf';
Font.register({ family: "IRANSans", src: IRANSans });

const styles = StyleSheet.create({
    page: {fontSize: 11,paddingTop: 10,paddingLeft: 20,paddingRight: 20,flexDirection: 'column', fontFamily:'IRANSans', color:'#116466' },

    spaceBetween : {flex : 1,flexDirection: 'row',alignItems:'center',justifyContent:'space-between',color: "#3E3E3E" },

    titleContainer: {flexDirection: 'row',marginTop: 24},
    
    logo: { width: 90 },

    reportTitle: { textAlign: 'center' },

    addressTitle : {}, 
    
    
    number : {}, 
    
    address : { },
    
    theader : {marginTop : 20,paddingTop: 4 ,paddingLeft: 7 ,flex:1,height:20, backgroundColor : '#DEDEDE',borderColor : '#D9B08C',borderWidth:1, textAlign:'center'},

    theader2 : { flex:2, borderWidth:1},

    tbody:{ paddingTop: 4 , paddingLeft: 7 , flex:1, borderColor : '#D9B08C', borderWidth:1, borderWidth:1, textAlign:'center'},
    tbody2:{ flex:2, borderWidth:1, }
    
});


// const sendAddress = () => (
//     <View style={styles.address}>
//         <text>hiii</text>
//     </View>
// );


// const receiverAddress = () => (
//     <View style={styles.address}>
        
//     </View>
// );

// const journalNumber = () => (
//     <View style={styles.number}>
        
//     </View>
// );

// const receiverName = () => (
//     <View style={styles.titleContainer}>
        
//     </View>
// );

// const receiverPhone = () => (
//     <View style={styles.number}>
        
//     </View>
// );



    const TableHead = () => {
        return(

            <View style={{ width:'100%', flexDirection :'row', marginTop:10, direction:'rtl'}}>
            
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>تحصیلات</Text>   
            </View> 
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>شهر</Text>   
            </View>
            
            <View style={styles.tbody}>
               <Text style={{direction:'rtl'}}>شماره تماس منزل</Text>   
            </View>
            <View style={styles.tbody}>
                <Text style={{direction:'rtl'}} >شماره همراه</Text>   
            </View>
            <View style={[styles.tbody]}>
                <Text style={{direction:'rtl'}} > نام خانوادگی </Text>   
            </View>
            <View style={styles.tbody } >
                <Text style={{direction:'rtl'}}>نام</Text>   
            </View>
            
       
        </View>
        )
        
        
    };

    const TableBody = (props) => (
        
        props.printData?.map((receipt)=>
            {
                return( <Fragment key={receipt.personID}>
                    <View style={{ width:'100%', flexDirection :'row', direction:'rtl'}}>
                        <View style={[styles.tbody]}>
                            <Text style={{direction:'rtl'}} >{ ""+receipt.degree=== null ? "---" : receipt.degree}</Text>   
                        </View> 
                        <View style={[styles.tbody]}>
                            <Text style={{direction:'rtl'}} >{ ""+receipt.city.cityName}</Text>   
                        </View>
                       
                        <View style={[styles.tbody]}>
                            <Text style={{direction:'rtl'}} >{ ""+receipt.homeNumber === null ? "---": receipt.homeNumber}</Text>   
                        </View>
                        <View style={styles.tbody}>
                            <Text style={{direction:'rtl'}}>{"" + receipt.phoneNumber}</Text>   
                        </View>
                        <View style={styles.tbody}>
                            <Text style={{direction:'rtl'}}>{receipt.lastName}</Text>   
                        </View>
                        <View style={styles.tbody}>
                           <Text style={{direction:'rtl'}}>{ receipt.firstName} </Text>   
                        </View>
                    </View>
                </Fragment>)
           
           })
    );

   
   
    

const Pdf_Report_All_Person = (props)=>
{  
        return(    
            <Document style={{padding:"5%", direction:"rtl"}}>
                <Page  style={styles.page}>              
                     <View style={{ width:'100%', flexDirection :'row', marginTop:10, direction:'rtl'}}>

                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>تحصیلات</Text>   
                        </View>
                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>محل سکونت</Text>   
                        </View>
                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>منزل</Text>   
                        </View>
                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>همراه</Text>   
                        </View>
                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>فامیل</Text>   
                        </View>
                        <View style={styles.tbody}>
                        <Text style={{direction:'rtl'}}>نام</Text>   
                        </View>
                    </View>
                    
                     <TableBody printData = {props.printData}/>
                </Page>
            </Document>
        )
   
    
    
}

export default Pdf_Report_All_Person;
